export default "__VITE_ASSET__ooVBO99r__"